export default [
  {
    path: "/",
    text: "Home",
  },
  {
    path: "/tours",
    text: "Tours",
  },
  {
    path: "/blogs",
    text: "Blogs",
  },
  {
    path: "/contact",
    text: "Contact",
  },
]
